module.exports = __webpack_public_path__ + "img/concluded-onboarding.608c0909.svg";